// import { useState } from 'react';
import logo from '../../assets/icons/logo.png';
import bag from '../../assets/icons/bag_icon.png';
import find from '../../assets/icons/lupa.png';
import profile from '../../assets/icons/profile.png';
import add from '../../assets/icons/adicionar_produto.png';
import './index.css';

const Header = ({ creatorModal, setCreatorModal, setHunterVisibilitie, hunterVisible }) => {
	return (
		<header className='Header__Container'>
			<img width='120px' alt='Logo' src={logo} />
			<div>
				<h1>MonkeyTech</h1>
				<nav>
					<ul>
						<li>
							<img width='30px' onClick={() => setHunterVisibilitie(!hunterVisible)} src={find} alt='Find Product' />
						</li>
						<li>
							<img width='30px' src={add} onClick={() => setCreatorModal(!creatorModal)} alt='Adicionar Produto' />
						</li>
						<li>
							<img width='30px' src={bag} alt='Bag' />
						</li>
						<li>
							<img width='30px' src={profile} alt='profile' />
						</li>
					</ul>
				</nav>
			</div>
		</header>
	);
};

export default Header;
